import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchConsignServices = createAction(ACTION.FETCH_CONSIGN_SERVICES.REQUEST);
export const fetchServices = createAction(ACTION.FETCH_SERVICES.REQUEST);
export const fetchConsignServiceGroups = createAction(ACTION.FETCH_CONSIGN_SERVICE_GROUPS.REQUEST, (params) => ({...params, type: "consign"}));
export const fetchServiceGroups = createAction(ACTION.FETCH_SERVICE_GROUPS.REQUEST);
